import { render, staticRenderFns } from "./layout_admin.vue?vue&type=template&id=0ff1d467&scoped=true&"
import script from "./layout_admin.vue?vue&type=script&lang=js&"
export * from "./layout_admin.vue?vue&type=script&lang=js&"
import style0 from "./layout_admin.vue?vue&type=style&index=0&id=0ff1d467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1d467",
  null
  
)

export default component.exports